export enum ECommonDropdownValues {
  Partners = 'Partners',
  TypeOfService = 'TypeOfService',
  Languages = 'Languages',
  Statuses = 'Statuses',
  Renters = 'Renters',
  Counties = 'Counties',
}

export type TCommonDropdownValues =
  | 'Partners'
  | 'TypeOfService'
  | 'Languages'
  | 'Statuses'
  | 'Renters'
  | 'Counties';

export const CommonDropdownValue = [
  'Partners',
  'TypeOfService',
  'Languages',
  'Statuses',
  'Renters',
];
